import axios from "axios";
import {ajaxmock} from './NumberSystemApiMock'
import { config } from "@num/config"

class NumberSystemApi {
  constructor() {
    this.endpoint = "/api"
    //TODO: simple detection of mock but it needs to be upgraded
    this.mock = config.mock == "true"
  }
  makeRequest(method, url, ...args) {
    if (this.mock) return ajaxmock(method, this.endpoint + url, ...args)
    return axios[method](this.endpoint + url, ...args)
  }
  orderNew() {
    throw new Error('not implemented')
  }
  orderUpdate(order) {
    if (!order.id || !order.status) {
      return Promise.reject('id or status missing')
    }
    return this.makeRequest("patch", '/order', order)
      .then((response) => this.translateApi(response))
      .catch((err) => this.translateError(err))
  }
  order(status, store = "") {
    if (!store) throw new Error("NumberSystemApi.order: No store provided")
    return this.makeRequest("get", '/order', { params: {status, store}})
      .then((response) => this.translateApi(response))
      .catch((err) => this.translateError(err))
  }
  status() {
    throw new Error('not implemented')
  }
  store() {
    throw new Error('not implemented')
  }

  translateApi(response) {
    if (response.status <= 200 || 299 > response.status) {
      if (response.data.status  == "nok") {
        return Promise.reject(response.data)
      } else {
        return Promise.resolve(response.data)
      }
    } else {
      return Promise.reject({ code: response.status })
    }
  }
  translateError(err) {
    return Promise.reject(err)
  }

}

export default NumberSystemApi